import { gql } from '@apollo/client';

export * from './softwareEscrowCreate.mutation.generated';

export const SOFTWARE_ESCROW_CREATE = gql`
  mutation softwareEscrowCreate($escrowRole: EscrowPartyTypeEnum!, $agreementForm: AgreementFormEnum!) {
    softwareEscrowCreate(
      input: { softwareEscrowCreateParams: { escrowRole: $escrowRole, agreementForm: $agreementForm } }
    ) {
      success
      errors
      softwareEscrow {
        id
      }
    }
  }
`;
